module.exports = __webpack_public_path__ + "media/images/static/top/urban/STAY-9c7177bdabf77f16ef0f338f5ec276f3.png";